import React, { Component } from "react";
import {
  Container,
  Grid,
  Segment,
  Header,
  Form,
  Message
} from "semantic-ui-react";

import * as LINKS from "../assets/Links";

class AdminDashboard extends Component {
  state = {
    file: null,
    emailList: "",
    error: false,
    success: false,
    errorMsg: ""
  };

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };

  handleUpload = event => {
    // console.log(event.target.files)
    console.log(event.target.files[0]);
    this.setState({ file: URL.createObjectURL(event.target.files[0]) });
    const csv = new FormData();
    csv.append("file", event.target.files[0]);
    fetch(
      LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.uploadCsvForMultipleOnboard,
      {
        method: "POST",
        body: csv
      }
    ).then(response => {
      response.json().then(body => {
        console.log(body);
      });
    });
  };

  handleInvite = () => {
    fetch(LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.sendInvite, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: localStorage.getItem("dat")
      },
      body: JSON.stringify({
        to_arr: this.state.emailList.split(",")
      })
    })
      .then(resp => resp.json())
      .then(data => {
        if (!data["success"]) {
          console.log(
            JSON.stringify({
              to_arr: this.state.emailList.split(",")
            })
          );
          console.log(data);
          this.setState({ error: true, errorMsg: data.error });
        } else {
          console.log(
            JSON.stringify({
              to_arr: this.state.emailList.split(",")
            })
          );
          console.log(data);
          this.setState({ success: true });
          console.log("Sent!");
        }
      });
  };

  render() {
    return (
      <Segment
        vertical
        style={{ padding: "2em 0em", backgroundColor: "#111111" }}
      >
        <Header as="h2" inverted textAlign="center">
          With Great Power, comes Great Responsibility
        </Header>
        <Container>
          <Grid /* celled="internally" */ columns="equal">
            <Grid.Column width="6">
              <Header as="h5" inverted>
                Send Invite(atmost 10 recipients)
              </Header>
              <Form
                inverted
                size="small"
                onSubmit={this.handleInvite}
                error={this.state.error}
                widths="equal"
              >
                <Form.TextArea
                  // inverted
                  name="emailList"
                  // icon="mail"
                  // iconPosition="left"
                  type="text"
                  label="Input emails seperated by commas"
                  onChange={this.handleChange}
                />
                <Message error={!this.state.error}>
                  <Message.Content>
                    {this.state.errorMsg + ", Reload and Retry Again..."}
                  </Message.Content>
                </Message>
                <Message positive success={!this.state.success}>
                  <Message.Content>Sent!</Message.Content>
                </Message>
                <Form.Button
                  // inverted
                  color="black"
                  size="large"
                  type="submit"
                  disabled={this.state.error || this.state.success}
                >
                  Invite
                </Form.Button>
              </Form>
            </Grid.Column>
          </Grid>
        </Container>
      </Segment>
    );
  }
}

const GetOut = () => (
  <Segment
    inverted
    vertical
    style={{ padding: "14em 0em", backgroundColor: "#111111" }}
  >
    <Header as="h2" textAlign="center">
      You should not be here! Go login!
    </Header>
  </Segment>
);

const validateUser = () => {
  if (!localStorage.getItem("dat")) {
    console.log("You should not be here!");
    return GetOut();
  } else {
    return <AdminDashboard />;
  }
};

const Dashboard = () => (
  <div>
    {validateUser()}
    {/* <Footer /> */}
  </div>
);

export default Dashboard;
